import { render, staticRenderFns } from "./WeekDayHeader.vue?vue&type=template&id=853580b2&scoped=true"
import script from "./WeekDayHeader.vue?vue&type=script&lang=js"
export * from "./WeekDayHeader.vue?vue&type=script&lang=js"
import style0 from "./WeekDayHeader.vue?vue&type=style&index=0&id=853580b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853580b2",
  null
  
)

export default component.exports